import type { Descendant, Node, NodeEntry } from "slate";
import { Editor, Element, Transforms } from "slate";
import type { CustomElement, ElementType, ParagraphElement } from "./types";

type ElementByType<T extends ElementType> = Extract<CustomElement, { type: T }>;

export function getNode<T extends ElementType>(
    editor: Editor,
    type: T,
): NodeEntry<ElementByType<T>> | undefined {
    const [node] = Editor.nodes(editor, {
        match: getMatch(type),
    });
    return node;
}

export function isActive(editor: Editor, type: ElementType): boolean {
    return getNode(editor, type) != null;
}

export function removeNodes(editor: Editor, type: ElementType): void {
    Transforms.removeNodes(editor, {
        match: getMatch(type),
    });
}

export function getMatch<T extends ElementType>(type: T) {
    return (n: Node): n is ElementByType<T> =>
        !Editor.isEditor(n) && Element.isElement(n) && n.type === type;
}

function getDefaultParagraph(): ParagraphElement {
    return {
        type: "paragraph",
        children: [{ text: "" }],
    };
}

export function getEmptyDescendants(): Descendant[] {
    return [getDefaultParagraph()];
}

export function isNotEmpty(value: Descendant[]): boolean {
    return value.some(nodeNotEmpty);
}

function nodeNotEmpty(node: Descendant): boolean {
    if (Element.isElement(node)) {
        return node.type !== "paragraph" || node.children.some(nodeNotEmpty);
    }
    return node.text.trim() !== "";
}
